import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }

import { onMounted, getCurrentInstance, ref } from 'vue';

// 中文、繁体、英文
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import zhTw from 'element-plus/dist/locale/zh-tw.mjs'
import en from 'element-plus/dist/locale/en.mjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const language = ref(localStorage.getItem("language") || 'cn')
const locale = ref('')
if (language.value == 'tc') {
	locale.value = zhTw
} else if (language.value == 'en') {
	locale.value = en
} else {
	locale.value = zhCn
}

const { proxy } = getCurrentInstance() as any;

onMounted(() => {
	let href = window.location.href;
	if (href.indexOf("localhost") > -1) {
		proxy.$store.commit("SetMode", 1);
	} else {
		proxy.$store.commit("SetMode", 2);
	}
	// var docEl = document.documentElement,
	// 	resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
	// 	recalc = function () {
	// 		var clientWidth = docEl.clientWidth;
	// 		if (!clientWidth) return;
	// 		docEl.style.fontSize = 100 * (clientWidth / 1920) + 'px';
	// 	};
	// if (!document.addEventListener) return;
	// window.addEventListener(resizeEvt, recalc, false);
	// document.addEventListener('DOMContentLoaded', recalc, false);
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_config_provider, { locale: locale.value }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }, 8, ["locale"])
  ]))
}
}

})